import { Pipe, PipeTransform } from '@angular/core';
import { TReceiptArraySug } from '@interfaces/new-receipt-body';

@Pipe({
	name: 'receiptType',
})
export class ReceiptTypePipe implements PipeTransform {
	transform(value: TReceiptArraySug): string {
		switch (value) {
			case 1:
				return 'מזומן';
			case 2:
				return "צ'ק";
			case 3:
				return 'חוב';

			default:
				return 'לא ידוע';
		}
	}
}
